<template>
    <div />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { initApplePay } from "../../api/modules/confirm";

export default {
    data() {
        return {
            transactionId: null
        };
    },
    computed: {
        texts() {
            return this.$t("page_payment");
        },
        ...mapGetters({
            flowLoading: "flow/isLoading",
            orderId: "order/getOrderId",
            applePayToken: "order/getApplePayToken"
        }),
        redirecturl() {
            return (
                window.location.origin +
                "/payment/" +
                `?provider=ApplePay&reference=${encodeURIComponent(
                    this.orderId
                )}` +
                `&transactionId=${encodeURIComponent(
                    this.transactionId
                )}`
            );
        }
    },
    mounted() {
        this.$emit("loading", this.texts.processing);
        return initApplePay(
            this.orderId,
            this.applePayToken
        ).then(response => {
            if (!response.ok) {
                throw new Error(JSON.stringify(response));
            }
            this.transactionId = response.responseBody.netaxeptTransactionId;
            window.location = this.redirecturl;
        });
    },
    methods: {
        ...mapActions({
            gotoNextStep: "flow/gotoNextStep"
        })
    }
};
</script>
